import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSkipModalData } from "../../redux/onboardingReducer";
import { getOnboardingDetails, onboardingQuestions, setDataForStates, setOnboardingData } from "../../shared/_services/common.services";
import Loader from "../Loader";
import AIChatBot from "./AIChatBot";


const QuestionTwo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const isFromUserQuestionnaire = location?.state?.fromUserQuestionnaire;
  const [showLoaderFour, setShowLoaderFour] = useState(false);
  const [otherInput, setOtherInput] = useState("");

  const checkAndFillDataForQuesFour = async () => {
    setShowLoaderFour(true);
    const questions = await onboardingQuestions("Which areas do you want clarity or help with?");
    // #69: same crash class as QuestionSix — an API failure leaves `.data`
    // undefined, a malformed 200 body can leave it non-array-but-truthy, and
    // currentQuestion[0] is read unguarded elsewhere in this screen.
    setCurrentQuestion(Array.isArray(questions?.data) ? questions.data : []);
    if (questions.status === 200) {
      const getOnboardingDetailsData = await getOnboardingDetails(questions?.data[0]?._id);
      if (getOnboardingDetailsData.status === 200) {
        let onboardingData = null;
        if (Array.isArray(getOnboardingDetailsData?.data?.data)) {
          onboardingData = getOnboardingDetailsData?.data?.data[0];
        } else if (getOnboardingDetailsData?.data?.error) {
          onboardingData = [];
        }

        let temp = setDataForStates(questions.data[0], onboardingData, false);
        if (temp.selectedData.length > 0) {
          setSelectedOptions([...temp.selectedData]);
        }
        setOtherInput(getOnboardingDetailsData.data?.data?.[0]?.others || "");
      }
    }
    setShowLoaderFour(false)
  }


  useEffect(() => {
    checkAndFillDataForQuesFour()
  }, []);

  const handleNextQuestion = async () => {
    setShowLoaderFour(true)
    let body = {};
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    body.clientId = currentUser?.user?._id;
    body.questionId = currentQuestion[0]?._id;
    body.others = otherInput;
    let selectedData = selectedOptions.map((data) => ({
      "name": data,
      "value": ""
    }));
    body = { ...body, selectedOptions: selectedData };
    if (isFromUserQuestionnaire) {
      let updateResponse = await setOnboardingData(body);
      setShowLoaderFour(false)
      if (updateResponse.status === 201) {
        navigate('/questionnaire');
      }
    } else {
      if (selectedOptions.length > 0) {
        let data = await setOnboardingData(body);
        setShowLoaderFour(false)

        if (data.status === 201) {
          navigate('/q3');
        }
      } else {
        setShowLoaderFour(false)
        dispatch(setSkipModalData(true));
      }
    }
  };

  const toggleOption = (option) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(option)) {
        return prevSelectedOptions.filter((item) => item !== option);
      } else {
        return [...prevSelectedOptions, option];
      }
    });
  };

  return (
    <>
      {showLoaderFour ? (
        <Loader />
      ) : (
        <div className="question-set">
          <div className="onboaring-quesn justify-content-between d-flex place-items-center">
            <h2>
              <span>Q2</span> 
              <div>Which areas do you want clarity or help with?
               <br/>
              <p>Pick as many as you want — helps your advisor understand your priorities.</p></div>
            </h2>
            {!isFromUserQuestionnaire && (
              <button
                type="button"
                className="as-btn-secondary"
                onClick={() => { navigate('/dashboard') }}
              >
                Continue Later</button>)}
          </div>

          <div className="onboarding-label mb-4">Click all that apply</div>

          <div className="onb-multi-select">
            {currentQuestion?.length > 0 && currentQuestion[0]?.options?.map((option) => (
              <div
                key={option}
                className={`onb-multi-select-option ${selectedOptions.includes(option) ? "if_selected" : ""} ${option.replace(/[\s\/]+/g, '')}`} // eslint-disable-line
                onClick={() => toggleOption(option)}
                style={{ cursor: "pointer" }}
              >
                <div className="text-wrap" style={{ width: "90%" }}>
                  {option}
                </div>
              </div>
            ))}
          </div>


        </div>)}

      {!showLoaderFour && (
        <div className="onboarding-footer">
          <div className="common-other-textbox mt-3 mb-3">
            <textarea
              name="otherText"
              id="otherText"
              placeholder="Something else"
              value={otherInput}
              onChange={(e) => setOtherInput(e.target.value)}
            ></textarea>
          </div>
          <div className="onboarding-footer-btns">
            <div className="d-flex justify-content-between w-100">
              {isFromUserQuestionnaire ? (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => {
                      navigate("/questionnaire")
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Update
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => navigate("/q1")}
                  >
                    ← Priority
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Planning Support →
                  </button>
                </>
              )}
            </div>
            <AIChatBot 
              questionName={currentQuestion[0]?.questionName}
              options={currentQuestion[0]?.options} firstMsg="Let’s talk about managing your money better. What aspects of money management do you find most challenging or want to improve?" />
          </div>
        </div>

      )}
    </>
  );
};

export default QuestionTwo;
